<template>
  <div>
    <filterForm
      :total="total"
      :filtered-total="filteredTotal"
      :in-print="inPrint"
      :category="category"
      :categories="categories"
      @updateInPrint="updateInPrint"
      @updateCategory="updateCategory"
      @reset="reset"
    />
    <div
      class="grid-container"
      data-publication-ajax-main-content
      data-publication-results-container="true"
      />

    <list
      v-if="!isLoading"
      :publications="publications"
      :current-page="currentPage"
      :last-page="lastPage"
      >
      <div
        data-pagination-mount
      />
    </list>
    <div
      v-if="!isLoading && hasMoreResults"
      class="grid-pagination--bottom"
      aria-controls="ajax-results-container"
      @click.prevent="paginate"
      >
      <button
        class="icon-link"
        aria-label="Show more results"
        >
        <span
          class="icon-link__text--list"
          v-html="showMoreLink"
          />
      </button>
    </div>
  </div>
</template>

<script>
  import { embedSVG } from 'Helpers/embedSVG';
  import filterForm from './form.vue';
  import list from './list.vue';

  export default {
    components: { filterForm, list },

    props: {
      initialInPrint: {type: Boolean, required: true},
      initialCategory: {type: String, required: true},
      initialPage: {type: Number, required: true},
    },

    data: function() {
      return {
        publications: [],
        categories: [],
        total: 0,
        isLoading: true,
        currentPage: this.initialPage,
        lastPage: 0,
        filteredTotal: 0,
        inPrint: this.initialInPrint,
        category: this.initialCategory,
      };
    },

    computed: {
      showMoreLink() {
        return `Show more <nobr>results${embedSVG("icon__plus--16--stroke.svg", "icon-link__svg")}</nobr>`;
      },

      hasMoreResults() {
       return this.lastPage > this.currentPage;
      },
    },

    created() {
      this.fetchPublicationCategories();
      this.fetchPublications(false);
    },

    methods: {
      fetchPublicationCategories: async function() {
        const url = `/publication_categories.json`;

        await fetch(url)
          .then(res => {
            this.total = Number(res.headers.get("x-publication-total"));
            return res.json();
          })
          .then(res => {
            this.categories = res;
          })
          .catch(error => {
            console.log(url + 'failed with error:', error);
          });
      },

      fetchPublications: async function(pagination) {
        if (!pagination) {
          this.isLoading = true;
        }
        let url = new URL("/publications.json", window.location.origin );
        url.searchParams.set("in_print", this.inPrint);
        url.searchParams.set("category", this.category);

        if (this.currentPage > 1) {
          url.searchParams.set("page", this.currentPage);
        }

        await fetch(url)
          .then(res => {
            this.lastPage = Number(res.headers.get("x-last-page"));
            this.filteredTotal = Number(res.headers.get("x-results-count"));
            return res.json();
          })
          .then(res => {
            if (res == null){
              this.publications = [];
            } else {
              if (pagination) {
                this.publications = this.publications.concat(res);
              } else {
                this.publications = res;
              }
            }
            this.isLoading = false;
          })
          .catch(error => {
            console.log(url + 'failed with error:', error);
          });
      },

      updateInPrint(val) {
        this.inPrint = val;
        this.currentPage = 1;
        this.updateHistory();
        this.fetchPublications(false);
      },

      updateCategory(val) {
        this.category = val.replaceAll(' ', '_');
        this.currentPage = 1;
        this.updateHistory();
        this.fetchPublications(false);
      },

      reset() {
        this.inPrint = false;
        this.category = this.categories[0].Name.String.replaceAll(' ', '_');
        this.currentPage = 1;
        this.updateHistory();
        this.fetchPublications(false);
      },

      paginate() {
        this.currentPage +=1;
        this.updateHistory();
        this.fetchPublications(true);
      },

      updateHistory() {
        const url = new URL(window.location);
        url.searchParams.set('in_print', this.inPrint);
        url.searchParams.set('category', this.category);
        if (this.currentPage > 1 ) {
          url.searchParams.set('page', this.currentPage);
        } else {
          url.searchParams.delete('page');
        }

        window.history.pushState({},'', url);
      }
    }
  };
</script>
